export const CodiceTipoPagamento = {
	CODICE_BONIFICO_SEPA: 'A',
	CODICE_BONIFICO_EXTRA_SEPA: 'B',
	CODICE_TESORERIA: 'C',
	CODICE_VAGLIA: 'D'
}